import React, { useState, useEffect } from "react";
import { Box } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { useNavigate, useLocation } from "react-router-dom";
import SuperAdminSidebar from "./SuperAdminSidebar";
import SuperAdminTopbar from "./SuperAdminTopbar";

export default function SuperAdminLayout({ children }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [isCollapsed, setIsCollapsed] = useState(false);

  useEffect(() => {
    // Check if user is authenticated
    const token = localStorage.getItem("superAdminToken");
    if (!token && location.pathname !== "/super-admin/auth/secure-access/login") {
      navigate("/super-admin/auth/secure-access/login");
    }
  }, [location, navigate]);

  return (
    <Box
      sx={{
        display: "flex",
        minHeight: "100vh",
        bgcolor: "background.default",
      }}
    >
      <SuperAdminSidebar isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />
      <Box
        sx={{
          flex: 1,
          marginLeft: isCollapsed ? "80px" : "280px",
          width: isCollapsed ? "calc(100% - 80px)" : "calc(100% - 280px)",
          minWidth: isCollapsed ? "calc(100% - 80px)" : "calc(100% - 280px)",
          transition: "all 0.3s ease",
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
        }}
      >
        <SuperAdminTopbar />
        <Box
          sx={{
            flex: 1,
            width: "100%",
            minWidth: "100%",
            maxWidth: "100%",
            p: 3,
            bgcolor: "background.default",
            backgroundImage: (t) =>
              t.palette.mode === "dark"
                ? `linear-gradient(180deg, ${alpha(t.palette.primary.main, 0.12)} 0%, ${t.palette.background.default} 40%)`
                : `linear-gradient(180deg, ${alpha(t.palette.primary.main, 0.04)} 0%, ${t.palette.background.default} 35%)`,
            overflow: "auto",
            boxSizing: "border-box",
          }}
        >
          {children}
        </Box>
      </Box>
    </Box>
  );
}

